module.exports = __webpack_public_path__ + "static/media/pg.4359608e.svg";